'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name criticalTakeoverAlert
    * @description Initializes critical takeover alert
    * This is the full screen alert that won't let you use the site
    * until you acknwledge it.
    **/

    var initialize = function () {
        
        // UNIGNORABLE ALERT
        var $unignorableAlerts = $('.critical-unignorable-alert');
        if ($unignorableAlerts && $unignorableAlerts.length > 0) {
            var newAlertVersion = $unignorableAlerts.attr('data-alert-version');
            var viewedAlertVersion = window.localStorage.getItem('viewedCriticalMessage');
            if (!viewedAlertVersion || viewedAlertVersion !== newAlertVersion) {
                window.localStorage.setItem('viewedCriticalMessage', newAlertVersion);
                showUnignorableAlert($unignorableAlerts[0]);
            }
        }

        $('.unignorable-alert-close').on('click', function () {
            var $this = $(this);
            var $unignorableAlertContainer = $this.closest('.critical-unignorable-alert');
            $unignorableAlertContainer.removeClass('show');

            var bodyEl = document.getElementsByTagName('body')[0];
            bodyEl.style.overflowY = 'auto';
        });
    }

    function showUnignorableAlert(alertContainerEl) {
        var $alertContainer = $(alertContainerEl);
        if ($alertContainer && $alertContainer.length > 0) {
            $alertContainer.addClass('show');
            var bodyEl = document.getElementsByTagName('body')[0];
            bodyEl.style.overflowY = 'hidden';
        }
    }

    return {
        initialize: initialize
    };
}())